import { getLastFromPath, makeId, Spacer } from '@oy/uidesktop';
import {
  ProductFeatureIcon,
  ProductFeatureIconName,
  SystemIcon,
} from '@oy/uiicon';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { useTranslate } from 'src/hooks';
import { menuDropdownIconHiddenList } from '../../constants';
import styles from '../Sidebar.module.css';
import { useMenuDropdownImpl } from './useMenuDropdownImpl';

type MenuDropdownProps = {
  title: string;
  path: string;
  children: ReactNode;
  titleAdditionalComponent?: ReactNode;
  icon?: string;
  isWhitelisted?: boolean;
  isIconHidden?: boolean;
  firstChildPath?: string;
};

const MenuDropdown = ({
  title,
  path,
  children,
  titleAdditionalComponent,
}: MenuDropdownProps) => {
  const { getTranslation } = useTranslate();
  const isNoIcon = menuDropdownIconHiddenList.includes(title ?? '');

  const {
    state,
    setIsHover,
    setIsSubHover,
    isSidebarCollapsed,
    getIconColor,
    onDropdownClick,
    elementRef,
  } = useMenuDropdownImpl({
    id: title + path,
  });
  const { show } = state;
  return (
    <div
      className={styles.navItemDropdown}
      id={makeId('menuDropdown', getLastFromPath(path))}
      ref={elementRef}
    >
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        onClick={onDropdownClick}
        data-tooltip-id="menu-tooltip"
        data-tooltip-content={title}
        data-tooltip-place="right"
      >
        {!isNoIcon && (
          <Spacer right={Spacer.Size.XS}>
            <ProductFeatureIcon
              name={path.substring(1) as ProductFeatureIconName}
              color={getIconColor()}
              size={24}
            />
          </Spacer>
        )}
        <span className={styles.menuTitle}>
          <Spacer tag="span">{title && getTranslation(title)}</Spacer>
          {titleAdditionalComponent && titleAdditionalComponent}
        </span>
        <div className={styles.arrowIcon}>
          <SystemIcon
            name={show ? 'arrow-up' : 'arrow-down'}
            size={16}
            color={getIconColor()}
          />
        </div>
      </div>
      {show && (
        <section
          onMouseEnter={() => setIsSubHover(true)}
          onMouseLeave={() => setIsSubHover(false)}
          className={classNames(styles.dropdownContainer, {
            [styles.collapsed]: isSidebarCollapsed,
          })}
        >
          {children}
        </section>
      )}
    </div>
  );
};

export default MenuDropdown;
